<div class="d-flex flex-column flex-nowrap mh-100 minw-100">
	<div class="fw-bold">
		<ng-content select="[evasysSelectorLabel]"></ng-content>
	</div>
	<div class="rounded-1 border">
		<ng-content></ng-content>
	</div>
</div>
